import { capitalCase, kebabCase } from 'change-case'

export default {
  kebabCase,
  titleCase: capitalCase,
}
